angular.module('pgminer',[]);

(function(){

})(angular.module('pgminer'));